import { useEffect, useState } from "react";
import useForm from "antd/es/form/hooks/useForm";
import request from "project-config/services/request/request";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";
import { IUserNameRecord } from "../types/modify-name";

export function useChangeName() {
  const [openNameModal, setOpenNameModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [changeNameForm] = useForm();
  const [changeNameLoading, setChangeNameLoading] = useState(false);
  const [leftTimes, setLeftTimes] = useState(0);
  const [recordData, setRecordData] = useState<IUserNameRecord[]>([]);
  const { fetchUserData } = useGlobalStore();

  const { t } = useTranslation("error");
  const { t: centerT } = useTranslation("center");
  const fetchLeftTimes = async () => {
    const { data } = await request.post<number>(
      "/api/rendering/user/getChangeUserNameResidueCount"
    );
    setLeftTimes(data || 0);
  };
  const fetchRecordData = async () => {
    const { data } = await request.post<IUserNameRecord[]>(
      "/api/rendering/user/getChangeUserNameList"
    );
    setRecordData(data ?? []);
  };
  const submitChangeName = () => {
    setChangeNameLoading(true);

    changeNameForm
      .validateFields()
      .then(async () => {
        const afterUserName = changeNameForm.getFieldValue("afterUserName");
        const { code } = await request.post(
          "/api/rendering/user/changeUserName",
          {
            afterUserName,
          }
        );

        setChangeNameLoading(false);

        if (code === 200) {
          message.success(centerT("message_success"));
          fetchUserData();
        } else {
          message.error(t(`error_${code}`));
          changeNameForm.resetFields();
        }
        setOpenNameModal(false);
      })
      .catch((e) => {
        setChangeNameLoading(false);
      });
  };

  const clearChangeNameForm = () => {
    changeNameForm.resetFields();
    setChangeNameLoading(false);
    setOpenNameModal(false);
  };
  useEffect(() => {
    fetchLeftTimes().catch(console.trace);
  }, []);
  useEffect(() => {
    if (!openViewModal) return;
    fetchRecordData().catch(console.trace);
  }, [openViewModal]);

  return {
    openNameModal,
    setOpenNameModal,
    changeNameForm,
    changeNameLoading,
    submitChangeName,
    clearChangeNameForm,
    setOpenViewModal,
    openViewModal,
    leftTimes,
    recordData,
  };
}
